// src/components/guards/GuardsStats.jsx
import React from 'react';
import { Users, Shield, Calendar } from 'lucide-react';
import { useTheme } from '../../theme/ThemeContext';

const GuardsStats = ({ totalGuards, activeGuards, inactiveGuards, recentlyJoined }) => {
  const { theme } = useTheme();

  return (
    <div className="mb-8 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
      {/* Total Guards */}
      <div className="group cursor-pointer rounded-2xl border border-slate-100 bg-white p-6 shadow-sm transition-all duration-300 hover:scale-105 hover:shadow-lg">
        <div className="mb-4 flex items-start justify-between">
          <div
            className="rounded-xl p-3 transition-transform group-hover:scale-110"
            style={{
              backgroundColor: theme.primary[50],
            }}
          >
            <Users
              className="h-6 w-6"
              style={{ color: theme.primary[600] }}
            />
          </div>
        </div>
        <h3 className="mb-1 text-sm font-medium text-slate-600">
          Total Guards
        </h3>
        <p className="text-3xl font-bold text-slate-800">{totalGuards}</p>
      </div>

      {/* Active Guards */}
      <div className="group cursor-pointer rounded-2xl border border-slate-100 bg-white p-6 shadow-sm transition-all duration-300 hover:scale-105 hover:shadow-lg">
        <div className="mb-4 flex items-start justify-between">
          <div
            className="rounded-xl p-3 transition-transform group-hover:scale-110"
            style={{
              backgroundColor: theme.primary[50],
            }}
          >
            <Shield
              className="h-6 w-6"
              style={{ color: theme.primary[600] }}
            />
          </div>
          <span className="rounded-full bg-emerald-100 px-2 py-1 text-xs font-semibold text-emerald-700">
            On duty
          </span>
        </div>
        <h3 className="mb-1 text-sm font-medium text-slate-600">
          Active Guards
        </h3>
        <p className="text-3xl font-bold text-slate-800">{activeGuards}</p>
      </div>

      {/* Inactive Guards */}
      <div className="group cursor-pointer rounded-2xl border border-slate-100 bg-white p-6 shadow-sm transition-all duration-300 hover:scale-105 hover:shadow-lg">
        <div className="mb-4 flex items-start justify-between">
          <div
            className="rounded-xl p-3 transition-transform group-hover:scale-110"
            style={{
              backgroundColor: theme.primary[50],
            }}
          >
            <Users
              className="h-6 w-6"
              style={{ color: theme.secondary[600] }}
            />
          </div>
        </div>
        <h3 className="mb-1 text-sm font-medium text-slate-600">
          Inactive / On Leave
        </h3>
        <p className="text-3xl font-bold text-slate-800">
          {inactiveGuards}
        </p>
      </div>

      {/* Recently Joined */}
      <div className="cursor-pointer rounded-2xl bg-gradient-to-br from-emerald-500 to-teal-600 p-6 text-white shadow-lg transition-all duration-300 hover:scale-105 hover:shadow-xl">
        <div className="mb-4 flex items-start justify-between">
          <div className="rounded-lg bg-white/20 p-2 backdrop-blur-sm">
            <Calendar className="h-6 w-6" />
          </div>
          <span className="rounded-full bg-white/20 px-2 py-0.5 text-xs">
            New
          </span>
        </div>
        <h3 className="mb-1 text-lg font-bold">Recent Joinees</h3>
        <p className="text-3xl font-bold">{recentlyJoined}</p>
        <p className="mt-2 text-sm text-white/80">
          Track onboarding and allocate routes to new guards.
        </p>
      </div>
    </div>
  );
};

export default GuardsStats;
